import ParameterTracker from './parameter-tracker';

class PurewickDataService {

  constructor() {
    this.handleDOMReady = this.handleDOMReady.bind(this);
    this.getPaidCampaignData = this.getPaidCampaignData.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.updatePaidCampaignParameters = this.updatePaidCampaignParameters.bind(this);

    document.addEventListener('DOMContentLoaded', this.handleDOMReady);
    window.addEventListener('message', this.handleMessage, false);
  }

  handleDOMReady() {
    this.purewickIFrame = document.getElementById('purewick-iframe');
    this.getPaidCampaignData();
  }

  getPaidCampaignData() {
    if (this.purewickIFrame) {
      this.purewickIFrame.contentWindow.postMessage({
        action: 'getData',
        key: 'url_params'
      }, '*');
    }
  }

  /**
   *
   * @param {Array} params
   */
  updatePaidCampaignParameters(params) {
    const paidCampaignParams = new URLSearchParams();

    for (const param of params) {
      paidCampaignParams.set(param[0], param[1]);
    }

    ParameterTracker.setParamaterValues(paidCampaignParams);

    ParameterTracker.storeUrlParameters();
  }

  handleMessage(event) {
    const { type, data } = event.data;

    try {
      if (type === 'getData'){
        this.updatePaidCampaignParameters(data);
      }
    } catch (e) {
      console.log(e);
    }
  }
}

export default PurewickDataService;
